import { forwardRef, type HTMLAttributes } from 'react';
import { cn } from '@/lib/utils/cn';

type GlassCardProps = HTMLAttributes<HTMLDivElement> & {
  /** Enable hover lift effect. */
  interactive?: boolean;
  /** Higher-opacity variant for foreground panels. */
  elevated?: boolean;
};

export const GlassCard = forwardRef<HTMLDivElement, GlassCardProps>(
  ({ className, interactive, elevated, ...props }, ref) => (
    <div
      ref={ref}
      className={cn(
        'rounded-[18px] border',
        elevated ? 'glass-hi' : 'glass',
        interactive &&
          'cursor-pointer transition-all duration-200 hover:-translate-y-0.5 hover:bg-[var(--glass-hi)]',
        className,
      )}
      {...props}
    />
  ),
);
GlassCard.displayName = 'GlassCard';
